"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReinsuranceCustomerService = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconReinsuranceCustomerService = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M19.731 15h-2.276a.455.455 0 0 1-.455-.454V9.454c0-.25.204-.454.455-.454h2.273c.27.02 1.272.825 1.272 3.018 0 2.183-1 2.967-1.269 2.982M7.001 9.454v5.092c0 .246-.258.454-.562.454H4.462C4.153 15 3 14.254 3 12.018 3 9.788 4.165 9 4.462 9H6.44c.304 0 .561.208.561.454M19.731 8h-.763c-.308-3.722-2.876-6-6.858-6-4.043 0-6.746 2.328-7.076 6h-.572C3.604 8 2 9.179 2 12.018 2 14.832 3.604 16 4.462 16H6.44C7.3 16 8 15.348 8 14.546V9.454C8 8.652 7.3 8 6.44 8h-.375c.323-3.096 2.562-5 6.045-5 3.411 0 5.527 1.863 5.83 5h-.485C16.652 8 16 8.652 16 9.454v5.092c0 .802.652 1.454 1.455 1.454H18c-.003 1.94-.268 3.825-3.095 3.992A1.5 1.5 0 0 0 13.5 19h-3a1.501 1.501 0 0 0 0 3h3a1.5 1.5 0 0 0 1.412-1.013C18.962 20.769 19 17.472 19 16h.731c.915 0 2.27-1.266 2.27-3.982C22 9.179 20.521 8 19.73 8" })] })));
};
exports.IconReinsuranceCustomerService = IconReinsuranceCustomerService;
exports.IconReinsuranceCustomerService.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconReinsuranceCustomerService;
